<div class="generic-error-container">
  <ds-icon name="{{ops.iconName}}" [size]="24" [fill]="false" ariaLabel="Buscar"
    style="color: var(--ds-foundation-colors-role-primary-400)">
  </ds-icon>

  <h2 class="ds-text-h2-bold">{{ops.title}}</h2>
  <p class="ds-text-body-l-regular" [innerHTML]="ops.subtitle"></p>  
  <ds-card variant="filled">
    <span class="ds-text-h4-bold">¿Necesitas ayuda?</span>
    <p class="ds-text-body-regular elimina-margen">
      Llámanos al
      <a [href]="helpLinks.phone.url" (click)="onHelpClick(helpLinks.phone)">
        {{ helpLinks.phone.text }}</a>,

      escríbenos al WhatsApp
      <a [href]="helpLinks.whatsapp.url" [target]="helpLinks.whatsapp.target" rel="noopener noreferrer"
        (click)="onHelpClick(helpLinks.whatsapp)">
        {{ helpLinks.whatsapp.text }}</a>

      o agenda una
      <a [routerLink]="helpLinks.video.url" (click)="onHelpClick(helpLinks.video)">
        {{ helpLinks.video.text }}</a>.
    </p>
  </ds-card>


  <p><ds-button-v2 class="btn-generic-error" label="{{ops.buttonTextPrimary}}" emphasis="primary" size="m"
      *ngIf="ops.buttonTextPrimary"
      (click)="goToPage(ops.buttonElementoPrimary, ops.buttonTextPrimary, ops.buttonElementoTipoPrimary, ops.buttonUrlPrimary)" />
  </p>
  <p><ds-button-v2 class="btn-generic-error pi-btn-2" label="{{ops.buttonTextSecondary}}" emphasis="secondary" size="m"
      *ngIf="ops.buttonTextSecondary"
      (click)="goToPage(ops.buttonElementoSecondary, ops.buttonTextSecondary, ops.buttonElementoTipoSecondary, ops.buttonUrlSecondary)" />
  </p>
</div>